export const MOSCOW_ID = 1;
export const REGIONS_WITH_UNDERGROUND = [MOSCOW_ID, 2, 4593, 4743, 4777, 4885, 4897, 4966];
export const PIK_PROMO_REGIONS = [1, 4593];
